module.exports = __webpack_public_path__ + "img/user-01.d09da647.jpg";